module.exports = __webpack_public_path__ + "static/media/Icon - gasplant   .f8f14bd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - gasplant   .svg
// module id = 71
// module chunks = 0